import { MainCollectionsContent } from '@/features/main/main-collections/main-collections-content/main-collections-content';

export class MainCollections {
	private readonly element: HTMLElement;
	private contentElements: Array<Element>;
	private contents: Array<MainCollectionsContent>;

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.init();
	}

	public init = (): void => {
		this.contentElements = Array.from(this.element.querySelectorAll('.main-collections__content'));
		this.contents = this.contentElements.map((element) => new MainCollectionsContent(element));
	};
}
